/* global axios */
import ApiClient from './ApiClient';

// Sante-CRM: Lixeira (registros em soft delete) — admin-only
class TrashAPI extends ApiClient {
  constructor() {
    super('trash', { accountScoped: true });
  }

  get({ recordType, page = 1 } = {}) {
    return axios.get(this.url, {
      params: { record_type: recordType, page },
    });
  }

  restore({ recordType, id }) {
    return axios.post(`${this.url}/restore`, {
      record_type: recordType,
      id,
    });
  }

  destroyPermanently({ recordType, id }) {
    return axios.delete(`${this.url}/destroy`, {
      params: { record_type: recordType, id },
    });
  }
}

export default new TrashAPI();
